import { AsyncPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ListQueryStateService } from 'src/app/shared/services/list-query-state.service';
import { IAssignment } from '../models/assignment';
import { AssignmentStorageService } from '../storage/assignment-storage.service';

@Component({
    selector: 'app-assignment',
    templateUrl: './assignment.component.html',
    styleUrls: ['./assignment.component.css'],
    standalone: false
})
export class AssignmentComponent implements OnInit {

  constructor(
    private assignmentStore : AssignmentStorageService,
    private asyncPipe: AsyncPipe,
    private router: Router,
    private listQueryState: ListQueryStateService
  ) { }

  public assignment$: Observable<IAssignment | null> =
    this.assignmentStore.assignment$;

  ngOnInit(): void {
  }

  reloadAssignment(){
    this.assignmentStore.getAssignment(
      this.asyncPipe.transform(this.assignment$).id
      )
  }

  /** Back to the list with the paging/sort/filter the user left it with. */
  goBack(){
    this.router.navigate(['/assignments'], {
      queryParams: this.listQueryState.getQueryParams('assignments')
    });
  }

  ngOnDestroy() {
    // gets called after resolver --> assignments will be empty after creation (& reload)
    // this.assignmentStore.resetStore();
  }

}
